import { t } from "@lingui/core/macro";

export enum SchemaErrorMessage {
  PhoneRequired = "phone.required",
  PhoneInvalid = "phone.invalid",
  PreferredLanguageRequired = "preferredLanguage.required",
}

const getMessages = () => ({
  [SchemaErrorMessage.PhoneRequired]: t`The phone is required`,
  [SchemaErrorMessage.PhoneInvalid]: t`The phone is invalid`,
  [SchemaErrorMessage.PreferredLanguageRequired]: t`The preferred language is required`,
});

export const getFormErrorMessage = (msg: string): string => {
  return getMessages()[msg as keyof ReturnType<typeof getMessages>] || t`The field is invalid`;
};
